export enum CapitalizationStatusEnum {
  inIssue = 'IN_ISSUE',
  issued = 'ISSUED',
  awaiting_payment = 'AWAITING_PAYMENT',
  canceled = 'CANCELED',
  pending = 'PENDING',
  ransom_requested = 'RANSOM_REQUESTED',
  ransom_paid = 'RANSOM_PAID',
}
